import { render, staticRenderFns } from "./NoProductList.vue?vue&type=template&id=8fa4d6f2&scoped=true&"
import script from "./NoProductList.vue?vue&type=script&lang=js&"
export * from "./NoProductList.vue?vue&type=script&lang=js&"
import style0 from "./NoProductList.vue?vue&type=style&index=0&id=8fa4d6f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa4d6f2",
  null
  
)

export default component.exports